import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref } from "vue";
var _hoisted_1 = { class: "post-outter-container" };
var _hoisted_2 = ["id", "href"];
var _hoisted_3 = ["src", "alt"];
var _hoisted_4 = {
    class: "post-summary",
    style: { "margin": "0.5rem", "height": "100%", "position": "relative", "display": "flex", "flex-direction": "column", "flex-grow": "1", "width": "72.5%" }
};
var _hoisted_5 = ["title"];
var _hoisted_6 = { class: "post-footer" };
var _hoisted_7 = { class: "post-tags" };
var _hoisted_8 = { class: "post-tag" };
var _hoisted_9 = ["title"];
import { computed, onMounted, ref, toRef } from "vue";
import tools from "@/utils/tools";
export default /*@__PURE__*/ _defineComponent({
    __name: 'PostBoxRowNormal',
    props: {
        propPost: Object,
    },
    setup: function (__props) {
        //待完善：未加载完成时禁用hover
        var isLoadImg = ref(false);
        var attribute = __props;
        var post = toRef(attribute, "propPost");
        if (!post.value)
            throw new Error("post is required");
        var postUrl = computed(function () {
            var _a;
            return "http://".concat(window.location.host, "/post/").concat((_a = post.value) === null || _a === void 0 ? void 0 : _a.id);
        });
        function onLoad() {
            isLoadImg.value = true;
        }
        function onError() {
            window.$message.error("图片加载失败");
        }
        onMounted(function () {
            var _a, _b, _c, _d;
            var instance = document.querySelector("#post-".concat((_a = post.value) === null || _a === void 0 ? void 0 : _a.id));
            instance === null || instance === void 0 ? void 0 : instance.setAttribute("post-id", String((_b = post.value) === null || _b === void 0 ? void 0 : _b.id));
            instance === null || instance === void 0 ? void 0 : instance.setAttribute("post-title", ((_c = post.value) === null || _c === void 0 ? void 0 : _c.title) || "");
            instance === null || instance === void 0 ? void 0 : instance.setAttribute("post-category", ((_d = post.value) === null || _d === void 0 ? void 0 : _d.category) || "");
        });
        function coverPath() {
            var _a, _b;
            return "https://".concat(window.location.host, "/md/").concat((_a = post.value) === null || _a === void 0 ? void 0 : _a.id, "/").concat((_b = post.value) === null || _b === void 0 ? void 0 : _b.cover_filename);
        }
        return function (_ctx, _cache) {
            var _a, _b, _c, _d, _e, _f, _g;
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("a", {
                    class: "post-container",
                    id: "post-".concat((_a = post.value) === null || _a === void 0 ? void 0 : _a.id),
                    href: postUrl.value,
                    target: "_blank"
                }, [
                    _createElementVNode("div", {
                        class: _normalizeClass([
                            'postimg-container',
                            { 'postimg-container-no-mask': !isLoadImg.value },
                        ])
                    }, [
                        _createElementVNode("img", {
                            src: coverPath(),
                            onLoad: onLoad,
                            onError: onError,
                            class: "post-cover-img",
                            alt: (_b = post.value) === null || _b === void 0 ? void 0 : _b.title
                        }, null, 40, _hoisted_3)
                    ], 2),
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", {
                            class: "post-title",
                            title: (_c = post.value) === null || _c === void 0 ? void 0 : _c.title
                        }, _toDisplayString((_d = post.value) === null || _d === void 0 ? void 0 : _d.title), 9, _hoisted_5),
                        _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("div", _hoisted_7, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_e = post.value) === null || _e === void 0 ? void 0 : _e.tags, function (item, index) {
                                    return (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                        _cache[0] || (_cache[0] = _createElementVNode("svg", {
                                            t: "1725449131372",
                                            class: "icon",
                                            viewBox: "0 0 1024 1024",
                                            version: "1.1",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            "p-id": "1454"
                                        }, [
                                            _createElementVNode("path", {
                                                d: "M428.63173571 98.52447645a51.78153127 51.78153127 0 0 1 41.94304 60.01479347L444.78757334 304.87387614h205.46911407l28.99765688-164.30279703a51.78153127 51.78153127 0 1 1 102.00961661 17.96819081L755.47675853 304.87387614H874.47071645a51.78153127 51.78153127 0 0 1 0 103.56306254h-137.27283913l-36.50597926 207.12612264H822.68918518a51.78153127 51.78153127 0 0 1 0 103.56306254h-140.2761671l-27.02995911 153.32511289a51.78153127 51.78153127 0 0 1-102.00961541-17.96819202L577.24472889 719.12612386H371.72383289l-27.02995911 153.32511289a51.78153127 51.78153127 0 0 1-102.0096154-17.96819202L266.5555437 719.12612386H149.52928355a51.78153127 51.78153127 0 0 1 0-103.56306254h135.25335943l36.55775997-207.12612264H201.31081482a51.78153127 51.78153127 0 1 1 0-103.56306254h138.2566874l28.99765688-164.30279703a51.78153127 51.78153127 0 0 1 60.06657661-42.04660266zM595.42004622 615.56306132l36.55776119-207.12612264h-205.520896l-36.50597925 207.12612264h205.46911406z",
                                                "p-id": "1455",
                                                fill: "#bfbfbf"
                                            })
                                        ], -1)),
                                        _createElementVNode("span", null, _toDisplayString(item), 1)
                                    ]));
                                }), 256))
                            ]),
                            _createElementVNode("div", {
                                class: "post-datetime",
                                title: _unref(tools).formatDatetime(new Date(((_f = post.value) === null || _f === void 0 ? void 0 : _f.create_time) || ''))
                            }, _toDisplayString(_unref(tools).countHowManyTimesAgo(((_g = post.value) === null || _g === void 0 ? void 0 : _g.create_time) || "")), 9, _hoisted_9)
                        ])
                    ])
                ], 8, _hoisted_2)
            ]));
        };
    }
});
